<div class="layout-conatiner text" [ngStyle]="style" *ngIf="alarm">
    <div class="detail-container">
        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.alarm" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.name | uppercase }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.channelNumber" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.channel }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.status" | translate }}</div>
            </div>
            <div class="detail-content">
                <div class="status">
                    <app-alarm-status-icon [statusText]="alarm.level">
                    </app-alarm-status-icon>
                    <div>{{ alarm.status | uppercase }}</div>
                </div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.value" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.value | uppercase }}</div>
            </div>
        </div>

        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.category" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>{{ alarm.category }}</div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.occurence" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>
                    {{ alarm.occurrenceAt | date: "yyyy/MM/dd" : "UTC" }}
                    {{ alarm.occurrenceAt | date: "HH:mm" : "UTC" }}
                </div>
            </div>
        </div>
        <div>
            <div class="detail-title">
                <div>{{ "alarm.detail.header.update" | translate }}</div>
            </div>
            <div class="detail-content">
                <div>
                    {{ alarm.recoveryTime | date: "yyyy/MM/dd" : "UTC" }}
                    {{ alarm.recoveryTime | date: "HH:mm" : "UTC" }}
                </div>
            </div>
        </div>
        <div>
            <button (click)="setVisible(false)">
                {{ "alarm.button.close" | translate }}
            </button>
        </div>
    </div>
</div>
